"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatusVersionCardRow = exports.TaskStatusVersionCard = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const core_2 = require("@sierralabs/core");
const core_ui_1 = require("@sierralabs/core-ui");
const TaskAuditLogList_1 = __importDefault(require("../components/TaskAuditLogList"));
const TaskStatusLabel_1 = __importDefault(require("../components/TaskStatusLabel"));
const useGetVersionedTaskStatusLogs_1 = require("../hooks/useGetVersionedTaskStatusLogs");
const useParseTaskStatus_1 = require("../hooks/useParseTaskStatus");
const useTaskWorkflow_1 = require("../hooks/useTaskWorkflow");
const Task_event_1 = require("../Task.event");
const StyledCard = (0, styled_components_1.default)(core_1.Card) `
  position: relative;
  .title {
    margin-top: 0;
    font-weight: 500;
  }
  .status-text {
    margin: 0;
    padding-top: 20px;
  }
  .task-buttons {
    position: absolute;
    top: 12px;
    right: 12px;
  }
`;
const StyledTableRow = (0, styled_components_1.default)(core_1.TableRow) `
  background-color: #f7f8fc;
`;
const TaskStatusVersionCard = props => {
    const { task, cardProps, renderContent } = props;
    const limit = 10;
    const [page, setPage] = (0, react_1.useState)(0);
    const [selected, setSelected] = (0, react_1.useState)();
    const [groupedLogs, setGroupedLogs] = (0, react_1.useState)([]);
    const [showAuditLog, setShowAuditLog] = (0, react_1.useState)(false);
    const taskRef = (0, react_1.useRef)(task);
    const { statusLogList, isLoading, error, getStatusLogs } = (0, useGetVersionedTaskStatusLogs_1.useGetVersionedTaskStatusLogs)(task.id);
    const status = (0, useParseTaskStatus_1.useParseTaskStatus)(task.status) || 'N/A';
    const workflow = (0, useTaskWorkflow_1.useTaskWorkflow)(task);
    const getStatusLogsWithParams = (0, react_1.useCallback)(() => {
        getStatusLogs({ page, limit });
    }, [page, limit, getStatusLogs]);
    const refresh = (0, react_1.useCallback)(() => {
        // update page to 0, fetch if currently 0
        setPage(page => {
            page === 0 && getStatusLogsWithParams();
            return 0;
        });
    }, [getStatusLogsWithParams]);
    (0, react_1.useEffect)(() => {
        getStatusLogsWithParams();
    }, [getStatusLogsWithParams]);
    (0, react_1.useEffect)(() => {
        if (task !== taskRef.current) {
            taskRef.current = task;
            refresh();
        }
    }, [task, refresh]);
    // refresh on change status
    (0, react_1.useEffect)(() => {
        return Task_event_1.TaskEvent.handle(Task_event_1.TaskEventType.ChangeStatus, () => refresh());
    }, [refresh]);
    (0, react_1.useEffect)(() => {
        if (!(statusLogList === null || statusLogList === void 0 ? void 0 : statusLogList.data)) {
            return;
        }
        setGroupedLogs(logs => {
            if (statusLogList.page === 0) {
                logs = [];
            }
            return statusLogList.data.reduce((result, log) => {
                // skip log if version already exists (could be due to hot refresh)
                if (logs.some(l => l.version === log.version)) {
                    return result;
                }
                const previousGroup = result[result.length - 1];
                if (!previousGroup || previousGroup.version !== log.version) {
                    result.push({ version: log.version, statusLogs: [log] });
                }
                else {
                    previousGroup.statusLogs.push(log);
                }
                return result;
            }, Array.from(logs));
        });
    }, [statusLogList]);
    return (react_1.default.createElement(StyledCard, Object.assign({}, cardProps),
        react_1.default.createElement(core_ui_1.CardContent, { background: 'primary' },
            react_1.default.createElement(core_1.Typography, { variant: 'overline', className: 'status-text' }, "Status"),
            react_1.default.createElement(core_1.Typography, { variant: 'h4', className: 'title' }, status),
            react_1.default.createElement("div", { className: 'task-buttons' },
                react_1.default.createElement(core_1.Tooltip, { arrow: true, placement: 'top', title: showAuditLog ? 'Status Log' : 'Audit Log' },
                    react_1.default.createElement(core_1.IconButton, { size: 'small', color: 'secondary', className: 'audit-log', onClick: () => setShowAuditLog(!showAuditLog) },
                        react_1.default.createElement(icons_1.History, null))))),
        showAuditLog ? (react_1.default.createElement(TaskAuditLogList_1.default, { task: task })) : (react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { width: 1 }),
                        react_1.default.createElement(core_1.TableCell, { title: 'Version' }, "Ver."),
                        react_1.default.createElement(core_1.TableCell, null, "Status"),
                        react_1.default.createElement(core_1.TableCell, null, "Date and Time"),
                        react_1.default.createElement(core_1.TableCell, null, "Owner"))),
                react_1.default.createElement(core_1.TableBody, null,
                    isLoading && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 5, padding: 'none' },
                            react_1.default.createElement(core_1.LinearProgress, null)))),
                    error && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 5, padding: 'none' },
                            react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message)))),
                    groupedLogs.map(group => {
                        const isSelected = selected === group.version;
                        return (react_1.default.createElement(exports.TaskStatusVersionCardRow, { key: group.version, task: task, group: group, workflow: workflow, isSelected: isSelected, renderContent: renderContent, onIconClick: () => {
                                setSelected(!isSelected ? group.version : undefined);
                            } }));
                    }))))),
        (!statusLogList || statusLogList.total > (page + 1) * limit) && (react_1.default.createElement(core_1.Box, { textAlign: 'center', padding: 2 },
            react_1.default.createElement(core_1.Link, { variant: 'body2', component: 'button', onClick: () => setPage(page + 1) }, "Load More")))));
};
exports.TaskStatusVersionCard = TaskStatusVersionCard;
const TaskStatusVersionCardRow = props => {
    const { task, group, isSelected = false, onIconClick, renderContent } = props;
    const latestStatusLog = group.statusLogs[0];
    const collapsedContent = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_1.default.Fragment, null, renderContent === null || renderContent === void 0 ? void 0 :
            renderContent(group, latestStatusLog, isSelected),
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableBody, null, group.statusLogs.map(log => {
                    if (log === latestStatusLog)
                        return null;
                    return (react_1.default.createElement(StyledTableRow, { key: log.id },
                        react_1.default.createElement(core_1.TableCell, null),
                        react_1.default.createElement(core_1.TableCell, { width: 60 }, log.version),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(TaskStatusLabel_1.default, { task: task, status: log.status })),
                        react_1.default.createElement(core_1.TableCell, null, (0, core_2.formatDate)(log.created)),
                        react_1.default.createElement(core_1.TableCell, null,
                            log.createdBy.firstName,
                            " ",
                            log.createdBy.lastName)));
                })))));
    }, [group, latestStatusLog, task, isSelected, renderContent]);
    return (react_1.default.createElement(core_ui_1.CollapsibleRow, { colSpan: 5, open: isSelected, collapsedContent: collapsedContent, onIconClick: onIconClick },
        react_1.default.createElement(core_1.TableCell, { width: 60 }, group.version),
        react_1.default.createElement(core_1.TableCell, null,
            react_1.default.createElement(TaskStatusLabel_1.default, { task: task, status: latestStatusLog.status })),
        react_1.default.createElement(core_1.TableCell, null, (0, core_2.formatDate)(latestStatusLog.created)),
        react_1.default.createElement(core_1.TableCell, null,
            latestStatusLog.createdBy.firstName,
            ' ',
            latestStatusLog.createdBy.lastName)));
};
exports.TaskStatusVersionCardRow = TaskStatusVersionCardRow;
exports.default = exports.TaskStatusVersionCard;
//# sourceMappingURL=TaskStatusVersionCard.js.map